import React, { useState, useEffect } from "react";
import { Field, FieldArray, useFormikContext } from "formik";
import { get, isEmpty, isNull } from "lodash";
import { usDateFormat } from "../../../utils";
import {
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
  DatePicker,
  Link,
  SliderPanel,
} from "../../../components";
import EmployeeClassifictionSliderTable from "./EmployeeClassification/EmployeeClassifictionSliderTable";
import { getEmployeeClassificationType } from "../../../services";
import { useRequest } from "../../../abstracts";
import AddToolTip from "../../../components/AddToolTip";

const columns = [
  {
    label: "Classification type",
    className: "column-classificationType",
    columnName: "classificationTypeName",
    link: `link`,
  },
  {
    label: "Classification code",
    className: "column-classificationCode",
    columnName: "code",
  },
  {
    label: "Classification name",
    className: "column-classificationName",
    columnName: "classificationName",
  },
  {
    label: "Classification Start date",
    className: "column-startDate",
    columnName: "effectiveStartDate",
  },
  {
    label: "Classification End date",
    className: "column-endDate",
    columnName: "effectiveEndDate",
  },
];

const EmployeeClassificationFields = (props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [sidePanelData, setSidePanelData] = useState({});
  const [status, setStatus] = useState(false);
  const { fields, isEdit, isSave, changeInCmpyId, isCmpy } = props;

  const onViewButtonClick = (data) => {
    setSidePanelData(data);
    setModalOpen(true);
  };
  const { values, setFieldValue, setFieldError } = useFormikContext();

  const disabled = isEdit && !isSave;
  const [classifications, setClassifications] = useState([]);
  // const { response: classifications } = useRequest({
  //   method: getEmployeeClassificationType,
  //   payload: values.companyId,
  //   defaultResponse: [],
  // });
  const employeeClassificationList = get(values, "employeeClassifications", []);
  const employeeClassificationsIds = employeeClassificationList?.map((x) => {
    return x.classificationTypeId;
  });
  const employeeClassificationListNew = [
    ...employeeClassificationList,
    ...classifications?.filter(
      (_) => !employeeClassificationsIds.includes(_.id)
    ),
  ];
  useEffect(() => {
    if (values?.companyId && values.companyId != 0) {
      getEmployeeClassificationType(values.companyId).then((response) => {
        setClassifications(response);
      });
    }
  }, [values.companyId]);

  return (
    <div>
      <div className="census-employee-classification">
        <div className="w-100">
          <div className="d-flex justify-content-between mb-4">
            <div className="">
              <div className="m-0 plan-sub-heading mt-2">
                Employee Classification
              </div>
            </div>
          </div>
        </div>
        {disabled === true ? (
          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {console.log(
                employeeClassificationList,
                "gokul",
                classifications,
                employeeClassificationListNew
              )}
              {employeeClassificationListNew.map((source, index) => {
                return (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {!isEmpty(item.link) &&
                          !isEmpty(source["employeeClassificationHistory"]) ? (
                            <Link onClick={() => onViewButtonClick(source)}>
                              {source[item.columnName]}
                            </Link>
                          ) : item.dataMapper ? (
                            item.dataMapper[source[item.columnName]] || "-"
                          ) : item.columnName == "effectiveStartDate" ||
                            item.columnName == "effectiveEndDate" ? (
                            usDateFormat(source[item.columnName]) || "-"
                          ) : source[item.columnName]?.length > 30 ? (
                            <AddToolTip
                              className="short-desc"
                              name={source[item.columnName] || "-"}
                              placement="bottom"
                            >
                              {source[item.columnName].slice(0, 30) || "-"}...
                            </AddToolTip>
                          ) : (
                            source[item.columnName] || "-"
                          )}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        ) : (
          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            {console.log(classifications, employeeClassificationList, "dd")}
            <FieldArray name="employeeClassifications">
              {({ push, remove }) => {
                return (
                  <Table.Tbody>
                    {classifications &&
                      classifications.map((employeeDetails, index) => {
                        return (
                          <Table.Tr key={index}>
                            {columns.map((item, cellIndex) => {
                              if (!status) {
                                var _ = changeInCmpyId(values.companyId);
                                if (_) {
                                  setStatus(true);
                                  setFieldValue(
                                    `employeeClassifications[${index}].${item.columnName}`,
                                    null
                                  );
                                }
                              }
                              if (isEmpty(employeeClassificationListNew)) {
                                setFieldValue(
                                  `employeeClassifications[${index}].${item.columnName}`,
                                  null
                                );
                              }
                              const getContent = () => {
                                const columnName = item.columnName;
                                const fieldName = `employeeClassifications[${index}].${columnName}`;
                                const onDaySelected = (name, value) => {
                                  setFieldValue(name, value);
                                };
                                if (item.dataMapper) {
                                  return item.dataMapper[
                                    employeeDetails[columnName]
                                  ];
                                }
                                if (["code"].includes(columnName)) {
                                  return (
                                    <Field
                                      size="sm"
                                      name={`employeeClassifications[${index}].code`}
                                      value={
                                        employeeClassificationListNew[index] !=
                                          undefined &&
                                        employeeClassificationListNew[index]
                                          .code
                                      }
                                      popupContent={
                                        <SearchableList
                                          label="Select Classification Code"
                                          options={
                                            classifications &&
                                            classifications[
                                              index
                                            ].classifications.map(
                                              (classification, index) => ({
                                                label: classification.code,
                                                value: index,
                                              })
                                            )
                                          }
                                          onSelect={(value) => {
                                            var data =
                                              classifications[index]
                                                .classifications[value];
                                            setFieldValue(fieldName, data.code);
                                            setFieldValue(
                                              fields.classificationCode,
                                              data.code
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].classificationId`,
                                              data.id
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].classificationName`,
                                              data.name
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].classificationTypeName`,
                                              classifications[index]
                                                .classificationTypeName
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].effectiveStartDate`,
                                              null
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].effectiveEndDate`,
                                              null
                                            );
                                          }}
                                          selectedValue={
                                            employeeClassificationListNew[
                                              index
                                            ] != undefined &&
                                            employeeClassificationListNew[index]
                                              .code
                                          }
                                        />
                                      }
                                      disabled={isEdit && !isSave}
                                      component={FieldDropSide}
                                    />
                                  );
                                }

                                if (
                                  ["classificationName"].includes(columnName)
                                ) {
                                  return (
                                    <Field
                                      size="sm"
                                      name={columnName}
                                      value={
                                        employeeClassificationListNew[index] !=
                                          undefined &&
                                        employeeClassificationListNew[index]
                                          .classificationName
                                      }
                                      popupContent={
                                        <SearchableList
                                          label="Select Classification"
                                          options={
                                            classifications &&
                                            classifications[
                                              index
                                            ].classifications.map(
                                              (classification, index) => ({
                                                label: classification.name,
                                                value: index,
                                              })
                                            )
                                          }
                                          onSelect={(value) => {
                                            var data =
                                              classifications[index]
                                                .classifications[value];
                                            setFieldValue(fieldName, data.name);
                                            setFieldValue(
                                              fields.classificationName,
                                              data.name
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].code`,
                                              data.code
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].effectiveStartDate`,
                                              null
                                            );
                                            setFieldValue(
                                              `employeeClassifications[${index}].effectiveEndDate`,
                                              null
                                            );
                                          }}
                                          selectedValue={
                                            employeeClassificationListNew[
                                              index
                                            ] != undefined &&
                                            employeeClassificationListNew[index]
                                              .classificationName
                                          }
                                        />
                                      }
                                      disabled={isEdit && !isSave}
                                      component={FieldDropSide}
                                    />
                                  );
                                }

                                if (
                                  ["effectiveStartDate"].includes(columnName)
                                ) {
                                  return (
                                    <Field
                                      size="sm"
                                      name={`employeeClassifications[${index}].effectiveStartDate`}
                                      value={
                                        employeeClassificationListNew[index] !=
                                          undefined &&
                                        usDateFormat(
                                          employeeClassificationListNew[index]
                                            .effectiveStartDate
                                        )
                                      }
                                      direction="bottom"
                                      isDatePicker
                                      onClear={() =>
                                        onDaySelected(fieldName, null)
                                      }
                                      popupContent={
                                        <DatePicker
                                          onDayClick={(value) => {
                                            onDaySelected(fieldName, value);
                                          }}
                                          value={usDateFormat(
                                            employeeClassificationListNew[index]
                                              ?.effectiveStartDate
                                          )}
                                        />
                                      }
                                      component={FieldDropSide}
                                      disabled={isEdit && !isSave}
                                    />
                                  );
                                }

                                if (["effectiveEndDate"].includes(columnName)) {
                                  return (
                                    <Field
                                      size="sm"
                                      name={`employeeClassifications[${index}].effectiveEndDate`}
                                      value={
                                        employeeClassificationListNew[index] !=
                                          undefined &&
                                        usDateFormat(
                                          employeeClassificationListNew[index]
                                            .effectiveEndDate
                                        )
                                      }
                                      direction="CalendarLeftStyle"
                                      isDatePicker
                                      onClear={() =>
                                        onDaySelected(fieldName, null)
                                      }
                                      popupContent={
                                        <DatePicker
                                          onDayClick={(value) =>
                                            onDaySelected(fieldName, value)
                                          }
                                          value={usDateFormat(
                                            employeeClassificationListNew[index]
                                              ?.effectiveEndDate
                                          )}
                                        />
                                      }
                                      component={FieldDropSide}
                                      disabled={
                                        (isEdit && !isSave) ||
                                        (employeeDetails &&
                                          employeeDetails.isRequired)
                                      }
                                    />
                                  );
                                }
                                if (
                                  isCmpy != undefined &&
                                  !isEmpty(employeeClassificationListNew) &&
                                  !isNull(
                                    employeeClassificationListNew[index]?.code
                                  ) &&
                                  !isEmpty(
                                    employeeClassificationListNew[index]
                                      ?.employeeClassificationHistory
                                  )
                                ) {
                                  return (
                                    <Link
                                      onClick={() =>
                                        onViewButtonClick(
                                          employeeClassificationListNew[index]
                                        )
                                      }
                                    >
                                      {employeeDetails[columnName]}
                                    </Link>
                                  );
                                } else {
                                  return employeeDetails[columnName];
                                }
                              };

                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  {getContent()}
                                </Table.Td>
                              );
                            })}
                          </Table.Tr>
                        );
                      })}
                  </Table.Tbody>
                );
              }}
            </FieldArray>
          </Table>
        )}
        <SliderPanel
          isOpen={isModalOpen}
          size="80"
          onClose={() => setModalOpen(!isModalOpen)}
          backdropClicked={() => setModalOpen(!isModalOpen)}
        >
          <EmployeeClassifictionSliderTable data={sidePanelData} />
        </SliderPanel>
        <br />
      </div>
    </div>
  );
};

export default EmployeeClassificationFields;
